module.exports = __webpack_public_path__ + "static/media/2.9a23a4a4.jpg";